<header class="header-area p-relative headerStyle" [class.sticky-header]="isSticky">
    <div class="navbar-area navbar-style-four" [class.sticky-box-shadow]="isSticky">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light" [class.active]="classApplied">
                
                <!-- Logo -->
                <a class="navbar-brand" routerLink="/">
                    <img [src]="sidebarLogo" alt="Staten Driving School Logo" class="logo-img">
                </a>
                
                <!-- Mobile Toggle -->
                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button>
                
                <!-- Navigation Menu -->
                <div class="collapse navbar-collapse" [class.show]="classApplied" id="navbarSupportedContent">
                    <ul class="navbar-nav main-nav">
                        <li class="nav-item">
                            <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <i class="bx bx-home-alt"></i> Home
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/packages" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <i class="bx bx-package"></i> Packages
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/schedule-of-fees" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <i class="bx bx-calendar"></i> Schedule of Fees
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/courses" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <i class="bx bx-book-open"></i> Course
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/news" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                                <i class="bx bx-news"></i> News
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/locations" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <i class="bx bx-map"></i> Location
                            </a>
                        </li>
                    </ul>
                    
                    <!-- User Menu -->
                    <ul class="navbar-nav user-nav">
                        <li class="nav-item dropdown" *ngIf="userName">
                            <a href="javascript:void(0)" class="nav-link user-dropdown" (click)="toggleClass2()">
                                <i class="bx bx-user-circle"></i>
                                <span>{{userName}}</span>
                                <i class="bx bx-chevron-down dropdown-arrow" [class.rotated]="classApplied2"></i>
                            </a>
                            <ul class="dropdown-menu" [class.show]="classApplied2">
                                <li class="nav-item">
                                    <a routerLink="/authentication/update-user-details" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                        <i class="bx bx-user"></i> {{ "MENU.ProfileSettings" | translate }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/student-calendar" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                        <i class="bx bx-calendar"></i> My Lesson Calendar
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/student-exam-calendar" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                        <i class="bx bx-calendar-check"></i> My Exam Calendar
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/payment/user-paymnet-history" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                        <i class="bx bx-history"></i> User Payment History
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)="logout()" class="nav-link logout-link">
                                        <i class="bx bx-log-out"></i> {{ "MENU.SingOut" | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item" *ngIf="!userName">
                            <a routerLink="/authentication/login" class="nav-link login-btn">
                                <i class="bx bx-log-in"></i> Login
                            </a>
                        </li>
                    </ul>
                </div>
                
                <!-- Cart Button -->
                <div class="others-option">
                    <a routerLink="/payment/pending-pakages" class="cart-wrapper-btn">
                        <i class='bx bx-cart-alt'></i>
                        <span class="cart-count">{{packagesCount}}</span>
                    </a>
                </div>
            </nav>
        </div>
    </div>
</header>

 